import { render, staticRenderFns } from "./SaleHeader.vue?vue&type=template&id=7fc8f74c&scoped=true&"
import script from "./SaleHeader.vue?vue&type=script&lang=js&"
export * from "./SaleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SaleHeader.vue?vue&type=style&index=0&id=7fc8f74c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc8f74c",
  null
  
)

export default component.exports